import { setValueActionCreator } from "../../Redux/Reducers/ValueReducer";
import { MessageBoardActionTypes } from "../const/messageBoardActionTypes";
import { ProjectOrTask } from "../types";

type MentionsValue = ProjectOrTask & {
    userIds: number[];
    emailOnlyMentions: number[];
};

export const setMentions = setValueActionCreator<MentionsValue>(MessageBoardActionTypes.SET_MENTIONS);

export type LoadMentionsAction = ReturnType<typeof loadMentions>;
type LoadMentionsPayload = ProjectOrTask & {
    forceReload?: boolean;
};
export const loadMentions = ({ forceReload, ...request }: LoadMentionsPayload) => ({
    type: MessageBoardActionTypes.LOAD_MENTIONS,
    request,
    forceReload,
});
